import graphql__dc270b0d792e19a2cf0d from "./__generated__/SetUpOnAccountPaymentMethodDialogMutation.graphql.ts";import * as React from "react";
import {useIntl} from "react-intl";
import {commitMutation, graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useRelayEnvironment} from "react-relay/hooks";
import type {SetUpOnAccountPaymentMethodDialogMutation} from "./__generated__/SetUpOnAccountPaymentMethodDialogMutation.graphql";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";

type SetUpOnAccountPaymentMethodDialogProps = {
    customerAccountIdentifier: string
    handleCloseDialog: () => {}
}

const SetUpOnAccountPaymentMethodDialog: React.FC<SetUpOnAccountPaymentMethodDialogProps> = ({customerAccountIdentifier, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<SetUpOnAccountPaymentMethodDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__dc270b0d792e19a2cf0d,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSetUpPaymentMethod'})
            }
        )
    }

    const initialValues = {
        customerAccountIdentifier: customerAccountIdentifier,
        paymentMethodType: 'OnAccount',
        paymentServiceType: 'Cabana',
        paymentTerms: 'UponReceipt'
    }

    const validationSchema = yup.object().shape({
        paymentTerms: yup.string().required(intl.formatMessage({id: 'validation.field.required'})),
    });

    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.SetUpOnAccountPaymentMethodDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.add'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'paymentMethod.paymentTerms'})}</Label>
                    <Field name="paymentTerms" as="select">
                        <option value="UponReceipt">{intl.formatMessage({id: 'paymentMethod.paymentTerms.uponReceipt'})}</option>
                        <option value="Net7">{intl.formatMessage({id: 'paymentMethod.paymentTerms.net7'})}</option>
                        <option value="Net15">{intl.formatMessage({id: 'paymentMethod.paymentTerms.net15'})}</option>
                        <option value="Net30">{intl.formatMessage({id: 'paymentMethod.paymentTerms.net30'})}</option>
                        <option value="Net60">{intl.formatMessage({id: 'paymentMethod.paymentTerms.net60'})}</option>
                    </Field>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default SetUpOnAccountPaymentMethodDialog;
